// export const scanServerPath = "https://api2.meinrbs.de:84/";

export const logoUri = "https://fptfiles.rbsonline.de/logos/";
export const avatarUri = "https://fptfiles.rbsonline.de/personen/";
